import './index.scss'

if($('.ny-banner').length > 0){
  $(document).scroll(function () {
    var scroH = $(document).scrollTop(); //滚动高度
    $('.ny-banner .img').css('transform','translateY('+ scroH / 3 +'px)')
  });
}